function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.23 10L18 3.23 16.77 2 10 8.77 3.23 2 2 3.23 8.77 10 2 16.77 3.23 18 10 11.23 16.77 18 18 16.77 11.23 10z",
  fill: "#B5BFCD"
});

var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref);
};

export default SvgClose;